// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__hlNqZ","label":"Section_label__27Wqc","contentWrap":"Section_contentWrap__2xlAX","footer":"Section_footer__SeD9t","footerInner":"Section_footerInner__2eUkl"};